export default [
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login", webpackPrefetch: true */ `./Login.vue`),
    meta: {
      title: 'Login',
      guest: true
    }
  },
  {
    path: '/esqueci-minha-senha',
    name: 'lost-password',
    component: () => import(/* webpackChunkName: "login", webpackPrefetch: true */ `./LostPassword.vue`),
    meta: {
      title: 'Esqueci minha senha',
      guest: true
    }
  },
  {
    path: '/redefinir-senha/:id',
    name: 'recovery-password',
    component: () => import(/* webpackChunkName: "login", webpackPrefetch: true */ `./RecoveryPassword.vue`),
    meta: {
      title: 'Redefinir Senha',
      guest: true
    }
  },
];
